<template>
  <div id="footer">
    <div class="follow-us">
      <span>Follow us</span>
      <a class="facebook cur" href="https://www.facebook.com/craitapp/" target="_blank"></a>
      <a class="twitter cur" href="https://twitter.com/craitapp?lang=e" target="_blank"></a>
    </div>
    <div class="copyright">Copyright &copy; Crait Corp. All Rights Reserved.</div>
  </div>
</template>

<script>
export default {
  name: 'footer',
  prop: {
    footerMt: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="scss">
#footer {
  clear: both;
  overflow: hidden;
  zoom: 1;
  font-size: 0.2rem;
  background-color: #eee;
  text-align: center;
  padding: 0.1rem 3.1rem;
  /*@media screen and (min-width: 760px) and (max-width: 1440px) {*/
    /*padding: .1rem .6rem;*/
  /*}*/
  @media screen and (max-width: 760px){
    padding: 0.1rem 0.2rem;
  }
  .cur {
    cursor: pointer;
  }
  .follow-us {
    float: left;
    @media screen and (max-width: 760px){
      float: none;
    }
    a {
      width: 0.35rem;
      height: 0.35rem;
      display: inline-block;
    }
    .facebook {
      background: url("../assets/images/new/icon_myfacebook@2x.png") no-repeat center;
      background-size: cover;
    }
    .twitter {
      background: url("../assets/images/new/icon_mytwitter@2x.png") no-repeat center;
      background-size: cover;
    }
  }
  .follow-us > * {
    vertical-align: middle;
  }
  .copyright {
    float: right;
    height: 0.35rem;
    line-height: 0.35rem;
    @media screen and (max-width: 760px){
      float: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Footer.vue?3ad58e57